/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionstatusnever2Inputs */

const en_actionstatusnever2 = /** @type {(inputs: Actionstatusnever2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No push – it ends before 8 am`)
};

const de_actionstatusnever2 = /** @type {(inputs: Actionstatusnever2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geht nicht als Mitteilung raus – endet vor 8 Uhr`)
};

/**
* | output |
* | --- |
* | "No push – it ends before 8 am" |
*
* @param {Actionstatusnever2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionstatusnever2 = /** @type {((inputs?: Actionstatusnever2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionstatusnever2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionstatusnever2(inputs)
	return de_actionstatusnever2(inputs)
});
export { actionstatusnever2 as "actionStatusNever" }